import { reactive, ref, watch } from "vue";
import { EXPORT_FORMAT, type ExportFormatType } from "hoxton-shared/enums/exports";

function createCheckboxWithInput<T>(defaultValue: T) {
    const enabled = ref(!!defaultValue);
    const value = ref(defaultValue);

    watch(value, newValue => {
        if (newValue) {
            enabled.value = true;
        } else {
            enabled.value = false;
        }
    });

    return reactive({
        enabled,
        value
    });
}

const duration = createCheckboxWithInput<string | undefined>(undefined);
const manualFps = createCheckboxWithInput<string | undefined>(undefined);
const captureAudio = ref(true);
const highQuality = ref(false);
const optimisedVideoFrames = ref(false);

export function useDownloadHTMLVideo() {
    function resetDownloadOptions() {
        duration.enabled = false;
        duration.value = undefined;
        manualFps.enabled = false;
        manualFps.value = undefined;
        captureAudio.value = true;
        highQuality.value = false;
        optimisedVideoFrames.value = false;
    }

    function computeQueryParams(exportFormat: ExportFormatType) {
        if (exportFormat !== EXPORT_FORMAT.VIDEO) {
            return {};
        }

        const params: {
            captureAudio: boolean;
            highQuality: boolean;
            droppedFramesOptimisation: boolean;
            duration?: number;
            fps?: number;
        } = {
            captureAudio: captureAudio.value,
            highQuality: highQuality.value,
            droppedFramesOptimisation: optimisedVideoFrames.value
        };

        if (duration.enabled && duration.value) {
            params.duration = Number(duration.value);
        }

        if (manualFps.enabled && manualFps.value) {
            params.fps = Number(manualFps.value);
        }

        return params;
    }

    return {
        duration,
        manualFps,
        captureAudio,
        highQuality,
        optimisedVideoFrames,

        // methods
        resetDownloadOptions,
        computeQueryParams
    };
}
